import {UIPatchNotes} from '../../../../../shared/scripts/patch_notes/UIPatchNotes.ts'
import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDPatchNotesSceneController {
    private readonly sidebarController: UISidebarController
    private readonly patchNotesSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.patchNotesSceneContainerDiv = document.getElementById('scene_discord_patch_notes_container') as HTMLDivElement

        const sidebar = this.patchNotesSceneContainerDiv.querySelector('#patch_note_sidebar') as HTMLElement
        sidebar.style.flexBasis = '240px'

        new UIPatchNotes(sidebar)
    }

    hide() {
        this.patchNotesSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.patchNotesSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
